export function convertToMinorValue(value) {
    return Math.round(value * 100);
}

export function convertToMajorValue(value) {
    return value / 100;
}